<template>
    <div class="">
        <div class="header-container">
            <div class="search-container">
                <div class="page-mode-input-wrapper">
                    <div class="page-mode-input">
                        <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                    </div>
                    <div class="input-btn" @click="handleSearch">
                        <i class="el-icon-search input-btn-icon"></i>
                        <span class="input-btn-label">搜索</span>
                    </div>
                </div>
            </div>
            <div class="header-btn-wrapper">
                <div class="header-btn" @click="handleAddPlanType" :class="{ 'disabled': isshow && isshow.expire == 1 }">
                    创建计划类型</div>
                <div class="header-btn" @click="handleAddPlan" style="margin-left:20px;"
                    :class="{ 'disabled': isshow && isshow.expire == 1 }">创建计划</div>
            </div>
        </div>
        <div v-if="tableData.length > 0" style="min-height:600px;">
            <div v-for="(item, key) in tableData" :key="key" class="plan-wrapper">
                <div class="plan-header-container">
                    <div class="plan-header-title-wrapper">
                        <img src="@/assets/img/plan.png" alt="" class="header-img">
                        <span class="plan-header-title">{{ item.typeName }}</span>
                    </div>
                    <div class="plan-header-btn-wrapper">
                        <i src="@/assets/img/edit.png" alt="" class="el-icon-edit-outline icon1"
                            @click="handleEditMode(item)" :class="{ 'disabled': isshow && isshow.expire == 1 }"></i>
                        <i src="@/assets/img/delete.png" alt="" class="el-icon-delete icon1" @click="handleDeleteMode(item)"
                            style="margin-left:30px;" :class="{ 'disabled': isshow && isshow.expire == 1 }"></i>
                    </div>
                </div>
                <div v-for="(childItem, childKey) in planData" :key="'child-' + childKey">
                    <div v-if="childItem.typeId == item.typeId" class="plan-content-wrapper"
                        @mouseenter="enterRow(childItem)" @mouseleave="leaveRow(childItem)">
                        <div class="plan-content-header-wrapper">
                            <div class="plan-content-title-wrapper">
                                <div v-if="childItem.status == 2" class="plan-content-title-btn">创建未完成</div>
                                <div class="plan-content-title">{{ childItem.planName }}</div>
                            </div>
                            <div class="plan-content-header-delete-wrapper">
                                <i v-if="activeHover == childItem.planId" class="el-icon-delete icon1"
                                    @click="handleDeletePlan(childItem)"
                                    :class="{ 'disabled': isshow && isshow.expire == 1 }"></i>
                                <!-- <img v-if="activeHover == childItem.planId" src="@/assets/img/delete.png" alt=""
                                    class="header-btn-img" @click="handleDeletePlan(childItem)"> -->
                            </div>
                        </div>
                        <div class="plan-table-wrapper">
                            <div class="plan-table-content">
                                <div class="plan-table-item">
                                    开始：{{ childItem.planStartTime }}
                                </div>
                                <div class="plan-table-item">
                                    结束：{{ childItem.planEndTime }}
                                </div>
                            </div>
                            <div class="plan-table-btn-wrapper">
                                <div class="plan-table-btn" @click="handlePalnDetail(childItem)">
                                    预览
                                </div>
                                <!-- <div :class="`plan-table-btn ${setEdit(childItem) ? 'not-into' : ''}`"
                                    @click="handleEditPlan(childItem)">
                                    编辑
                                </div> -->

                                <div :class="['plan-table-btn',
                                    { 'not-into': setEdit(childItem) },
                                    { 'disabled': isshow.expire === 1 }]" @click="handleEditPlan(childItem)">
                                    编辑
                                </div>

                                <div :class="`plan-table-btn ${childItem.status == 2 ? 'not-into' : ''}`"
                                    @click="handleEchartsReport(childItem)">
                                    统计报表
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="no-data-wrapper">
            <img src="@/assets/img/nodata.png" alt="" class="no-data-img">
            <div class="no-data-label">暂无管理计划！</div>
        </div>
        <div class="view-more-btn-wrapper">
            <div v-if="currentPage < totalPages" class="view-more-btn" @click="viewMore">查看更多</div>
        </div>

        <el-dialog title="" :show-close="true" width="542px" :visible.sync="typeDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>{{ typeDialogTitle }}</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <el-form :rules="formRules" ref="addTypeform" :model="addTypeform" label-width="120px">
                        <el-form-item label="计划类型名称" prop="typeName">
                            <el-input v-model="addTypeform.typeName" placeholder="请输入计划类型名称"></el-input>
                        </el-form-item>
                        <el-form-item label="计划类型排序" label-width="120px" prop="sortBy">
                            <el-input v-model="addTypeform.sortBy" placeholder="请输入数字"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialog-btn-wrapper">
                    <div class="dialog-btn dialog-cancel-btn" @click="cancelPlanMode">取消</div>
                    <div class="dialog-btn dialog-deal-btn" @click="addPlanMode">确定</div>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="" :show-close="true" width="542px" :visible.sync="noTypeDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div class="dialog-info-label">创建计划最少要先创建一个计划类型！</div>
                </div>
                <div class="dialog-btn-wrapper" style="justify-content:center;">
                    <div class="dialog-btn dialog-deal-btn" @click="handleNoType">确定</div>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="" :show-close="true" width="542px" :visible.sync="deleteModeDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div class="dialog-info-label">
                        删除计划类型将同时删除其学习计划，是否继续？
                    </div>
                </div>
                <div class="dialog-btn-wrapper" style="justify-content:center;">
                    <div class="dialog-btn dialog-deal-btn" @click="deleteMode">确定删除</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="" :show-close="true" width="542px" :visible.sync="deletePlanDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div class="dialog-info-label">
                        确认删除此学习计划？
                    </div>
                </div>
                <div class="dialog-btn-wrapper" style="justify-content:center;">
                    <div class="dialog-btn dialog-deal-btn" @click="deletePlan">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { studyPlanList, updatePlanMode, studyPlanModeList, deletePlanMode, deletePlanRow } from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            isshow: null,
            dept: '',
            token: '',
            searchVal: '',
            totalData: [],
            tableData: [],
            planData: [],
            currentPage: 1,
            totalPages: 1,
            activeHover: '',
            typeDialog: false,
            noTypeDialog: false,
            typeDialogTitle: '创建计划类型',
            typeMode: 'add',
            addTypeform: {
                typeName: '',
                sortBy: ''
            },
            formRules: {
                typeName: [
                    { required: true, message: '请输入计划类型名称', trigger: 'blur' }
                ],
                sortBy: [
                    { required: true, message: '请输入计划类型排序', trigger: 'blur' }
                ]
            },
            deleteModeDialog: false,
            activeDeleteMode: {},
            deletePlanDialog: false,
            activeDeletePlan: {}
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.isshow = JSON.parse(window.localStorage.getItem('gqxx'))

        this.getTableData();
    },
    methods: {
        getTableData() {
            studyPlanList({
                "adminDeptId": 0,
                "adminUserId": 0,
                "deptId": this.dept,
                "keyword": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 10000,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    //var lastData=this.totalData;
                    //this.totalData=lastData.concat(data);
                    this.totalData = data;
                    this.totalPages = res.data.totalPages;
                    this.resetTableData();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        //优化的代码解决只有一个删除后不生效的问题
        resetTableData() {
            const dataArr = this.totalData;
            const titleArr = [];
            const contentArr = [];

            for (let i = 0; i < dataArr.length; i++) {
                const item = dataArr[i];
                if (item.planId === 0) { // 严格相等检查
                    titleArr.push(item);
                } else {
                    contentArr.push(item);
                }
            }

            // 循环外一次性赋值
            this.tableData = titleArr;
            this.planData = contentArr;
        },
        // resetTableData() {
        //     var dataArr = this.totalData;
        //     var titleArr = [];
        //     var contentArr = [];
        //     for (var i = 0; i < dataArr.length; i++) {
        //         var item = dataArr[i];
        //         if (item.planId == 0) {
        //             titleArr.push(item);
        //         } else {
        //             contentArr.push(item);
        //         }
        //         if (i == dataArr.length - 1) {
        //             this.tableData = titleArr;
        //             this.planData = contentArr;
        //         }
        //     }
        // },
        handleSearch() {
            this.tableData = [];
            this.currentPage = 1;
            this.getTableData();
        },
        viewMore() {
            if (this.currentPage < this.totalPages) {
                this.currentPage = this.currentPage + 1;
                this.getTableData();
            }
        },
        enterRow(row) {
            var planId = row.planId;
            this.activeHover = planId;
        },
        leaveRow() {
            this.activeHover = '';
        },
        handleAddPlanType() {
            this.addTypeform = {
                typeName: '',
                sortBy: ''
            };
            this.typeMode = 'add';
            this.typeDialogTitle = '创建计划类型';
            this.typeDialog = true;
        },
        cancelPlanMode() {
            this.typeDialog = false;
        },
        handleEditMode(row) {
            this.addTypeform = row;
            this.typeMode = 'edit';
            this.typeDialogTitle = '编辑计划类型';
            this.typeDialog = true;
        },
        addPlanMode() {
            var addTypeform = this.addTypeform;
            if (addTypeform.typeName == '') {
                this.$message.error('请输入计划类型名称');
                return false;
            }
            if (addTypeform.sortBy == '') {
                this.$message.error('请输入计划类型排序');
                return false;
            }
            var sortBy = Number(addTypeform.sortBy);
            if (isNaN(sortBy) || sortBy < 0) {
                this.$message.error('请输入数字');
                return false;
            }
            var typeId = null;
            if (this.typeMode == 'edit') {
                typeId = addTypeform.typeId;
            }
            updatePlanMode({
                "deptId": this.dept,
                "sortBy": sortBy,
                "typeId": typeId,
                "typeName": addTypeform.typeName,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.typeDialog = false;
                    var message = this.typeDialogTitle;
                    this.$message({
                        message: `${message}成功`,
                        type: 'success'
                    });
                    this.totalData = [];
                    this.getTableData();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleAddPlan() {
            studyPlanModeList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    if (data.length > 0) {
                        var newPlan = {
                            id: '',
                            mode: 'add',
                            basicInfo: {
                                isFinsh: false,
                                content: {}
                            },
                            selectClass: {
                                isFinsh: false,
                                content: {}
                            },
                            addMeasure: {
                                isFinsh: false,
                                content: {},
                                question: []
                            },
                            addTest: {
                                isFinsh: false,
                                content: {},
                                question: []
                            },
                            addMember: {
                                isFinsh: false,
                                content: {}
                            }
                        };
                        window.localStorage.setItem('plan', JSON.stringify(newPlan));
                        this.$router.push(`/makePlan`);
                    } else {
                        this.noTypeDialog = true;
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleNoType() {
            this.noTypeDialog = false;
        },
        handleEchartsReport(row) {
            this.$router.push(`/echartsReport/${row.planId}`);
        },
        handlePalnDetail(row) {
            this.$router.push(`/planDetail/detail/${row.planId}`);
        },
        // 设置编辑
        setEdit(childItem) {
            let flag = true
            if (childItem.planStartTime) {
                var endtime = childItem.planStartTime.replace("/-/g", "/");//时间转换
                // 时间
                var date1 = new Date(endtime);
                // 现在时间
                var date2 = new Date();

                // 判断计划是否开始
                flag = date1 < date2 ? true : false;
            }
            return flag
        },
        // 判断是开始时间前进入编辑还是开始时间后
        getAfterStartTime(row) {
            let flag = false
            if (row.planStartTime) {
                var startTime = row.planStartTime.replace("/-/g", "/");//时间转换
                // 时间
                var date1 = new Date(startTime);
                // 现在时间
                var date2 = new Date();
                // 判断计划是否开始
                flag = date1 < date2 ? true : false;
            }
            return flag
        },
        handleEditPlan(row) {
            var newPlan = {
                id: row.planId,
                mode: 'edit',
                basicInfo: {
                    isFinsh: false,
                    content: {}
                },
                selectClass: {
                    isFinsh: false,
                    content: {}
                },
                addMeasure: {
                    isFinsh: false,
                    content: {},
                    question: []
                },
                addTest: {
                    isFinsh: false,
                    content: {},
                    question: []
                },
                addMember: {
                    isFinsh: false,
                    content: {}
                }
            };
            let isAfterStartTime = this.getAfterStartTime(row)
            window.localStorage.setItem('plan', JSON.stringify(newPlan));
            this.$router.push({ path: `/makePlan`, query: { isAfterStartTime } });
        },
        handleDeleteMode(row) {
            this.activeDeleteMode = row;
            this.deleteModeDialog = true;
        },
        deleteMode() {
            var id = this.activeDeleteMode.typeId;
            deletePlanMode(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.totalData = [];
                    this.deleteModeDialog = false;
                    this.$message({
                        message: `删除成功`,
                        type: 'success'
                    });
                    this.totalData = [];
                    this.getTableData();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleDeletePlan(row) {
            this.activeDeletePlan = row;
            this.deletePlanDialog = true;
        },
        deletePlan() {
            var id = this.activeDeletePlan.planId;
            deletePlanRow(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.deletePlanDialog = false;
                    this.$message({
                        message: `删除成功`,
                        type: 'success'
                    });
                    this.totalData = [];
                    this.getTableData();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        }
    }
}
</script>

<style scoped>
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.search-container {
    display: flex;
    align-items: center;
}

.page-mode-input-wrapper {
    display: flex;
    width: 425px;
}

.page-mode-input>>>.el-input__inner {
    width: 350px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.header-btn-wrapper {
    display: flex;
    margin-right: 15px;
}

.header-btn {
    height: 36px;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF9645;
    line-height: 36px;
    padding: 0px 18px 0px 18px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.header-btn:hover {
    cursor: pointer;
    color: #fff;
    background: #FF9645;
}

.plan-header-title-wrapper {
    display: flex;
    align-items: center;
}

.icon1 {
    cursor: pointer;
    color: #6D94FF;
    font-size: 22px;
}

.plan-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 10px;
}

.header-img {
    width: 30px;
    height: 30px;
}

.plan-header-title {
    margin-left: 17px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303B45;
}

.plan-header-btn-wrapper {
    display: flex;
    margin-right: 15px;
}

.header-btn-img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-wrapper {
    height: 164px;
    border-bottom: 1px solid #F0F0F0;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-wrapper:hover {
    background: rgb(248, 248, 248);
}

.plan-content-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 28px;
}

.plan-content-title-wrapper {
    display: flex;
    margin-left: 15px;
    align-items: center;
}

.plan-content-title-btn {
    width: 95px;
    height: 26px;
    background: #FE8766;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.plan-content-title {
    height: 30px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.plan-content-header-delete-wrapper {
    margin-right: 15px;
}

.plan-table-wrapper {
    display: flex;
    justify-content: space-between;
}

.plan-table-content {
    margin-left: 15px;
    margin-top: 15px;
}

.plan-table-item {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-top: 5px;
}

.plan-table-btn-wrapper {
    margin-right: 15px;
    display: flex;
}

.plan-table-btn-wrapper .not-into {
    pointer-events: none;
    color: #c0c4cc;
    border-color: #c0c4cc;
}

.plan-table-btn {
    margin-left: 20px;
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #3E63EE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.view-more-btn-wrapper {
    margin-top: 50px;
    margin-bottom: 20px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}

.team-manage-container>>>.el-dialog__body {
    padding: 0px !important;
}

.team-manage-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-info {
    text-align: center;
}

.dialog-btn-wrapper {
    display: flex;
    margin-top: 50px;
    justify-content: space-between;
}

.dialog-btn {
    width: 140px;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.dialog-cancel-btn {
    background: #fff;
    color: #3E63EE;
}

.dialog-cancel-btn:hover {
    background: #3E63EE;
    color: #fff;
    cursor: pointer;
}

.dialog-deal-btn {
    background: #3E63EE;
    color: #fff;
}

.dialog-deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.no-data-wrapper {
    min-height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    margin-top: 20px;
}

.disabled {
    border: 1px solid #f0f0f0 !important;
    pointer-events: none !important;
    /* 阻止鼠标事件 */
    cursor: no-drop !important;
    /* 鼠标变为禁止标志 */
    background-color: #f0f0f0 !important;

    /* 浅灰色背景 */
    color: #a9a9a9 !important;
    /* 深灰色文本 */
}
</style>


